<template>
  <button
    class="btn btn-dashed-question dashed-borders"
    type="button"
    @click="$emit('click')"
  >
    <slot>
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.418 6.21875C10.6992 6.5 10.7305 6.96875 10.4492 7.28125L8.19922 9.78125C8.07422 9.90625 7.88672 10 7.66797 10C7.48047 10.0313 7.26172 9.9375 7.13672 9.78125L5.88672 8.53125C5.57422 8.25 5.57422 7.78125 5.88672 7.5C6.16797 7.1875 6.63672 7.1875 6.91797 7.5L7.63672 8.1875L9.35547 6.25C9.63672 5.96875 10.1055 5.9375 10.418 6.21875ZM10.418 11.2188C10.6992 11.4688 10.7305 11.9688 10.4492 12.2813L8.19922 14.7813C8.07422 14.9063 7.88672 15 7.66797 15C7.48047 15.0313 7.26172 14.9375 7.13672 14.7813L5.88672 13.5313C5.57422 13.25 5.57422 12.7813 5.88672 12.4688C6.16797 12.1875 6.63672 12.1875 6.91797 12.4688L7.63672 13.1875L9.35547 11.25C9.63672 10.9688 10.1055 10.9375 10.418 11.2188ZM12.668 8C12.668 7.46875 13.1055 7 13.668 7H20.668C21.1992 7 21.668 7.46875 21.668 8C21.668 8.5625 21.1992 9 20.668 9H13.668C13.1055 9 12.668 8.5625 12.668 8ZM12.668 13C12.668 12.4688 13.1055 12 13.668 12H20.668C21.1992 12 21.668 12.4688 21.668 13C21.668 13.5625 21.1992 14 20.668 14H13.668C13.1055 14 12.668 13.5625 12.668 13ZM10.668 18C10.668 17.4688 11.1055 17 11.668 17H20.668C21.1992 17 21.668 17.4688 21.668 18C21.668 18.5625 21.1992 19 20.668 19H11.668C11.1055 19 10.668 18.5625 10.668 18ZM5.66797 18C5.66797 17.1875 6.32422 16.5 7.16797 16.5C7.98047 16.5 8.66797 17.1875 8.66797 18C8.66797 18.8438 7.98047 19.5 7.16797 19.5C6.32422 19.5 5.66797 18.8438 5.66797 18Z"
          fill="#781EFF"
          fill-opacity="0.88"
        />
      </svg>
      <span class="ml-6">{{ text }}</span>
    </slot>
  </button>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "Adicionar pergunta"
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-dashed-question {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 8px;
  color: #781effe0;
  font-family: "Noto Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;

  &.dashed-borders {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23CFAEFFFF' stroke-width='1.8' stroke-dasharray='8%2c 8' stroke-dashoffset='8' stroke-linecap='round'/%3e%3c/svg%3e");
    border-radius: 8px !important;
    background-repeat: no-repeat;
  }
}
</style>
